import React, { Component } from 'react'
import axios from 'axios';
import { Link } from 'react-router-dom'
import Button from './Button'
import server from '../server'
import 'react-notifications/lib/notifications.css';

class AsideLeft extends Component {
  state = {
    form: {
      message: '',
      email: ''
    },
    formError: {}
  }

  handleFormChange = e => {
    const input = e.target;
    this.setState({
      form: Object.assign(
          this.state.form,
          { [input.name]: input.value }
        )
    });
  }
  handleSubmit = e => {
    e.preventDefault();

    const data = new FormData(),
      form = this.state.form;

    data.append('title', 'Обратная связь - задать вопрос с левого панеля');
    data.append('message', form.message);
    data.append('email', form.email);

    axios.post(server.uri+'request', data)
      .then(() => {
        this.setState({
          form: { message: '', email: '' }
        });

        this.props.handleNotify({
          type: 'success',
          text: 'Ваш запрос прошел успешно, мы вскоре свяжемся с Вами'
        });
      })
      .catch(() => {
        this.props.handleNotify({
          type: 'error',
          text: 'Что то пошло не так... попробуйте позже'
        });
      });
  }

  render() {
    if( this.props.width !== undefined && this.props.width[1] < 992 ) return '';

    const user = this.props.user,
      form = this.state.form,
      formSettings = {
        required: true,
        onChange: this.handleFormChange
      };

    return (
      <aside className="page-aside aside_left">

        <header>
          <Link className="logo_white" to="/">
            <img src="/assets/imgs/logo-white.svg" alt="ICORE ITAC"/>
          </Link>
        </header>

        <section className="aside__menu">
          <ul>
            <li>
              <h3 className="aside__title">{ user ? 'Информация о подписке' : 'Меню' }</h3>

              <ul className={!user?'hide':''}>
                {
                  this.props.licenses && this.props.licenses.map((v,i) => (
                    <li key={i}><Link className="aside__menu__item" to={ '/cabinet#'+(i+1) }>{ v.title }</Link></li>
                  ))
                }
              </ul>
              
              <ul className={user?'hide':''}>
                {this.props.menu && this.props.menu.map( (v,i) => (
                    i ? <li key={i}><Link className="aside__menu__item" to={ '/'+v.uri }>{ v.menutitle ? v.menutitle : v.pagetitle }</Link></li> : ''
                ))}
              </ul>
            </li>
            <li>
              <Link className="aside__title" to="/infobase">База знаний</Link>
            </li>
          </ul>
        </section>

        <section className="callback">
          <form onSubmit={ this.handleSubmit }>

            <input type="hidden" name="title" value="Левый блок: Обратная свзяь - задать вопрос"/>

            <h3 className="aside__title aside__title_green">Обратная связь</h3>

            <div className="form-group">
              <label htmlFor="callbackMessage" className={ form.message.length && 'hide' }>Задайте вопрос...</label>
              <textarea id="callbackMessage" name="message" placeholder="Задайте вопрос..." rows="10" value={form.message} {...formSettings}></textarea>
            </div>

            <div className="form-group callback__email">
              <input id="callbackEmail" type="email" name="email" className="form__input" placeholder="email" value={form.email} {...formSettings}/>
            </div>

            <div className="callback__btns">
              <Button theme="success">Отправить</Button>
            </div>
          </form>
        </section>

        <section className="contacts">
          <h3 className="aside__title">Контакты</h3>
          <p className="aside__description">{ this.props.address }<br/><a href={`tel:${ this.props.phoneHref }`}>{ this.props.phone }</a></p>
        </section>

        <footer>
          <ul className="list_links">

            { this.props.emails.map( (v,i) => (
              <li key={i}><a href={`mailto:${v}`}>{v}</a></li>
            ))}

            <li><a href={ this.props.basesite }>{ this.props.basesite }</a></li>
          </ul>
        </footer>
      </aside>
    );
  }
}
export default AsideLeft
